import { ErrorMessage, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'
import { useStore } from '../../app/stores/store'
import AuthShell from '../../app/common/ui/AuthShell'
import { AppButton, AppInput, AppPasswordInput, AppStack, AppText, GunSlopWordmark } from '../../app/common/ui'

export default observer(function LoginForm () {
  const { userStore } = useStore()

  return (
    <AuthShell
      title={<GunSlopWordmark size="auth" />}
      subtitle="The Firearm Community"
    >
      <Formik
        initialValues={{ login: '', password: '', error: '' }}
        onSubmit={(values, { setErrors }) =>
          userStore.login({ login: values.login, password: values.password }).catch(() =>
            setErrors({ error: 'Invalid email/username or password.' })
          )
        }
      >
        {({ handleSubmit, isSubmitting, errors, handleChange, handleBlur, values }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <AppStack spacing="sm">
              <AppInput
                name="login"
                placeholder="Email or username"
                value={values.login}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="off"
                data-lpignore="true"
                data-form-type="other"
              />
              <AppPasswordInput
                name="password"
                placeholder="Password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage
                name="error"
                render={() => (
                  <AppText size="sm" color="red" mb="xs">
                    {errors.error}
                  </AppText>
                )}
              />
              <AppButton type="submit" loading={isSubmitting} fullWidth size="md">
                Sign In
              </AppButton>
            </AppStack>
          </form>
        )}
      </Formik>

      <AppStack spacing="xs" mt="lg" sx={{ alignItems: 'center' }}>
        <AppText size="xs" sx={{ color: '#58A6FF' }}>
          <Link to="/forgot-password" style={{ color: 'inherit' }}>
            Forgot password?
          </Link>
        </AppText>
        <AppText size="xs" sx={{ color: 'var(--gs-muted)' }}>
          Don&apos;t have an account?{' '}
          <AppText component={Link} to="/register" sx={{ color: '#58A6FF' }}>
            Create one →
          </AppText>
        </AppText>
      </AppStack>
    </AuthShell>
  )
})
